import { h } from 'preact';
import style from './style';
import cx from 'classnames';

/**
 * Header
 */
export default function Header({ children, secondary, title, transform, ...props }) {
	return (
		<header {...props} class={cx(style.header, props.class)}>
			<div class={cx(style.title, style[transform])}>{ title }{secondary && <small>{ secondary }</small>}</div>
			<div class={cx(style.right)}>{ children }</div>
		</header>
	);
}
